import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import LabPage from "@/pages/LabPage";
import PlaybookPage from "@/pages/PlaybookPage";
import ExperiencePage from "@/pages/ExperiencePage";
import ProgrammePage from "@/pages/ProgrammePage";
import TeamPage from "@/pages/TeamPage";
import ApplyPage from "@/pages/ApplyPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="admin-loading" data-testid="admin-loading">Checking access…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function AppShell() {
  const location = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/lab" element={<LabPage />} />
      <Route path="/playbook" element={<PlaybookPage />} />
      <Route path="/experience" element={<ExperiencePage />} />
      <Route path="/programme" element={<ProgrammePage />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/apply" element={<ApplyPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <Protected>
            <AdminDashboard />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
